import { requestApi } from '../util/network'

// 获取订单列表
export const getOrderList =
    (params, order_sn, state_type) =>
      requestApi(
        '/Sellerorder/order_list',
        'POST',
        {
          'order_sn': order_sn,
          'state_type': state_type,
          'page': params.page,
          'per_page': params.per_page
        },
        'seller'
      )
// 获取订单信息
export const getOrderInfo =
    (orderId,pickupCode='') =>
      requestApi(
        '/Sellerorder/order_info',
        'POST',
        {
          'order_id': orderId,
          'o2o_order_pickup_code': pickupCode
        },
        'seller'
      )
// 验证取货码
export const checkOrderPickupCode =
    (pickupCode) =>
      requestApi(
        '/Sellerorder/check_o2o_order_pickup_code',
        'POST',
        {
          'o2o_order_pickup_code': pickupCode
        },
        'seller'
      )
// 取货
export const pickupOrder =
    (orderId) =>
      requestApi(
        '/Sellerorder/pickup_order',
        'POST',
        {
          'order_id': orderId
        },
        'seller'
      )
// 接收订单
export const receiptOrder =
    (orderId) =>
      requestApi(
        '/Sellerorder/receipt_order',
        'POST',
        {
          'order_id': orderId
        },
        'seller'
      )
// 拒绝订单
export const rejectOrder =
    (orderId, reason) =>
      requestApi(
        '/Sellerorder/reject_order',
        'POST',
        {
          'order_id': orderId,
          'reason': reason
        },
        'seller'
      )
// 取消订单
export const cancelOrder =
    (orderId, reason) =>
      requestApi(
        '/Sellerorder/order_cancel',
        'POST',
        {
          'order_id': orderId,
          'reason': reason
        },
        'seller'
      )
// 修改商品价格
export const editGoodsPrice =
    (orderId, price) =>
      requestApi(
        '/Sellerorder/order_spay_price',
        'POST',
        {
          'order_id': orderId,
          'order_fee': price
        },
        'seller'
      )
// 修改配送费
export const editShippingFee =
    (orderId, price) =>
      requestApi(
        '/Sellerorder/order_ship_price',
        'POST',
        {
          'order_id': orderId,
          'shipping_fee': price
        },
        'seller'
      )
// 获取配送员列表
export const getDistributorList =
    (params, orderId) =>
      requestApi(
        '/Sellerorder/get_distributor_list',
        'POST',
        {
          'order_id': orderId,
          'page': params.page,
          'per_page': params.per_page
        },
        'seller'
      )
// 给订单指派配送员
export const deliverOrder =
    (orderId, o2oDistributorId) =>
      requestApi(
        '/Sellerorder/deliver_order',
        'POST',
        {
          'order_id': orderId,
          'o2o_distributor_id': o2oDistributorId
        },
        'seller'
      )
